import { Icon, Popup } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

export default function CopyIcon({ size = 12, value }) {
	const { t } = useTranslation();

	const [copied, setCopied] = useState(false);

	return (
		<Popup
			size="mini"
			position="top center"
			content={t("copied", "Copied")}
			on={copied}
			trigger={
				<Icon
					style={{ fontSize: size, cursor: "pointer", margin: 0 }}
					name="clone"
					onClick={(e) => {
						e.stopPropagation();
						navigator.clipboard.writeText(value);
						setCopied(true);
					}}
				/>
			}
		/>
	);
}
